import { createContext, useState } from "react";

export const UsuariosContext = createContext();

export const UsuariosProvider = ({ children }) => {

    const [users, setUsers] = useState([]); // Estado que armazena a lista de Usuários
    const [formData, setFormData] = useState({ nome: "", email: "", senha: "" }); // Estado que armazena o objeto formulário de dados para criação de usuário
    const [isModalOpen, setIsModalOpen] = useState(false); // Estado que armazena se o Modal está aberto
    const [isEditing, setIsEditing] = useState(false); // Estado que armazena se o usuário está editando
    const [userIdEdited, setUserIdEdited] = useState(null); // Estado que armazena o ID do usuário editado
    const [passwordOnly, setPasswordOnly] = useState(false); // Estado que armazena se o usuário está alterando a senha
    const [status, setStatus] = useState(""); // Estado que armazena o Filtro Status de Usuário (Ativos, Inativos ou Todos)


    return (
        <UsuariosContext.Provider value={{ users, setUsers, formData, setFormData, isModalOpen, setIsModalOpen, isEditing, setIsEditing, userIdEdited, setUserIdEdited, passwordOnly, setPasswordOnly, status, setStatus }}>
            {children}
        </UsuariosContext.Provider>
    );
};
